import { render, staticRenderFns } from "./MobileInboundRegister.vue?vue&type=template&id=2fdf15ba&scoped=true"
import script from "./MobileInboundRegister.vue?vue&type=script&lang=js"
export * from "./MobileInboundRegister.vue?vue&type=script&lang=js"
import style0 from "./MobileInboundRegister.vue?vue&type=style&index=0&id=2fdf15ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf15ba",
  null
  
)

export default component.exports